module.exports = __webpack_public_path__ + "static/media/texture-wood-grey-v.538e0aea.jpg";